"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGuidesContext = exports.GuidesProvider = exports.GuidesContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const device_1 = require("@completeanatomy/device");
const debounce_1 = __importDefault(require("lodash/debounce"));
const initialState = {
    isGuidesAvailable: false,
    isGuidesExpanded: false,
    isGuidesVisible: true,
    guidesGridWidth: 0,
    isHideGuidesPanel: false,
};
const standardAspectRatio = 0.75;
exports.GuidesContext = (0, react_1.createContext)([initialState, () => { }]);
function GuidesProvider({ children }) {
    const [state, setState] = (0, react_1.useState)(initialState);
    const { isMobile, isIOS } = (0, device_1.usePlatform)();
    (0, react_1.useEffect)(() => {
        const onResize = () => {
            const height = window.innerHeight;
            const innerWidthConvertedToStandardAspectRatio = height / (standardAspectRatio || height);
            const width = Math.round((window.innerWidth - innerWidthConvertedToStandardAspectRatio) / 2);
            const aspectRatio = window.innerHeight / window.innerWidth;
            const aspectDelta = Math.abs(standardAspectRatio - aspectRatio);
            const isAvailable = !isMobile && !isIOS && aspectDelta > 0.05;
            setState(prev => (Object.assign(Object.assign({}, prev), { isGuidesAvailable: isAvailable, isGuidesExpanded: isAvailable, isGuidesVisible: isAvailable, guidesGridWidth: isAvailable ? width : 0 })));
        };
        const debouncedResize = (0, debounce_1.default)(onResize, 100);
        window.addEventListener('resize', debouncedResize);
        onResize();
        return () => {
            window.removeEventListener('resize', debouncedResize);
        };
    }, [isIOS, isMobile]);
    return ((0, jsx_runtime_1.jsx)(exports.GuidesContext.Provider, { value: [state, setState], children: children }));
}
exports.GuidesProvider = GuidesProvider;
function useGuidesContext() {
    return (0, react_1.useContext)(exports.GuidesContext);
}
exports.useGuidesContext = useGuidesContext;
